<template>
  <form @submit.prevent="doSearch($event)" novalidate>
    <div class="columns is-multiline">
      <div class="column is-12-tablet is-auto-desktop">
        <label for="" class="label">Voucher Code</label>
        <input
            type="text"
            class="input"
            v-model="voucher"
            required
            name="voucher"
            v-validate="'required'"
            data-vv-as="voucher code"
        >
        <p class="help is-danger" v-show="errors.has('voucher')">{{ errors.first('voucher') }}</p>
      </div>
      <div class="column is-6-tablet is-auto-desktop">
        <label for="" class="label">First Name</label>
        <input
            type="text"
            class="input"
            v-model="firstName"
            required
            name="firstName"
            v-validate="'required'"
            data-vv-as="first name"
        >
        <p class="help is-danger" v-show="errors.has('firstName')">{{ errors.first('firstName') }}</p>
      </div>
      <div class="column is-6-tablet is-auto-desktop">
        <label for="" class="label">Last Name</label>
        <input
            type="text"
            class="input"
            v-model="lastName"
            required
            name="lastName"
            v-validate="'required'"
            data-vv-as="last name"
        >
        <p class="help is-danger" v-show="errors.has('lastName')">{{ errors.first('lastName') }}</p>
      </div>
      <div class="column is-12-tablet is-2-desktop">
        <label for="" class="label is-hidden-touch">&nbsp;</label>
        <button class="button is-primary is-fullwidth" :class="{'is-loading': loading}">Search</button>
      </div>
    </div>
  </form>
</template>

<script>
import GoogleAnalytics from "@mixins/analytics/index.js";
import { axios } from '@master';

export default {
  props: {
    resetErrors: {
      type: Boolean,
      default: false
    },
    shouldRedirect: {
      type: Boolean,
      default: true,
    }
  },
  emits: ['success'],
  mixins: [GoogleAnalytics],
  data() {
    return {
      loading: false,
      voucher: '',
      firstName: '',
      middleName: '',
      lastName: ''
    }
  },
  methods: {
    doSearch() {
      this.errors.clear();

      this.loading = true;

      axios.post(`/voucher/login`, {
        voucher: this.voucher,
        firstName: this.firstName,
        lastName: this.lastName
      }).then(response => {
        this.loading = false;
        this.gaEvent('engagement', 'login', 'Login', { method: 'internal' });
        axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrf;
        document.querySelector('meta[name="csrf-token"]').setAttribute('content', response.data.csrf);
        this.$emit('success', response.data);

        if (response.data?.shouldRedirect) {
          window.location.href = response.data?.redirectTo || '/';
        } else {
            window.location.href = '/';
        }
      }).catch(error => {
        this.loading = false;
        if(error.status == 422) {
          let errors = error.data.errors;
          for(let field in errors) {
            this.$validator.errors.add({
              field: field,
              msg: errors[field][0],
              scope: this.$options.scope
            });
          }
        } else {
            console.error(error);
        }
      });
    },
  },
  computed: {
    formIsInvalid() {
      return Object.keys(this.fields).some(key => {
        return this.fields[key].invalid;
      });
    }
  },
  watch: {
    resetErrors(reset) {
      if(reset == true) {
        this.$validator.reset();
      }
    }
  }
}
</script>
